<mat-dialog-content>
    <h2>Bem-vindo(a) à Feira do Livro</h2> 
    <h3>Para começar, inicie a sessão</h3>

    <form [formGroup]="model" (ngSubmit)="login()">            
        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="text" focus>
            @if (model.get('email')?.invalid) {
                <mat-error>Informe seu email</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hideSenha() ? 'password' : 'text'" formControlName="password" >
            <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="clickEventSenha1($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideSenha()"
                >
                <mat-icon>{{hideSenha() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            @if (model.get('password"')?.invalid) {
                <mat-error>Informe sua senha</mat-error>
            }
        </mat-form-field>

        <button type="submit" mat-flat-button class="btn-primary" (click)="login()">
            @if (_isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
            @else{
                Entrar
            }
        </button>

        <p class="text-center"><a (click)="forgotPassword()">Esqueci minha senha</a> ou <a (click)="openModalRegister()">não possuo conta</a></p>
    
    </form>

</mat-dialog-content>